import { Component, Input, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'combo-search',
  templateUrl: './combo-search.component.html',
  styleUrls: ['./combo-search.component.css']
})
export class ComboSearchComponent implements OnDestroy, OnChanges {
  private _filtroCtrl: FormControl;

  // Expõe a lista filtrada para o componente pai
  public itensFiltrados: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  protected _onDestroy = new Subject<void>();

  @Input() itens: any[] = [];
  @Input() searchProperty: string = 'descricao'; // Tornando a propriedade de busca configurável

  @Input()
  set filtroCtrl(control: FormControl) {
    if (control && control !== this._filtroCtrl) {
      this._filtroCtrl = control;

      // A inscrição agora acontece aqui e é destruída junto com o componente
      this._filtroCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filtrarItens();
        });

      // Executa o filtro uma vez para carregar os dados iniciais
      this.filtrarItens();
    }
  }

  get filtroCtrl(): FormControl {
    return this._filtroCtrl;
  }

  ngOnChanges(changes: SimpleChanges) {
    // Se a lista de 'itens' for alterada, o filtro é executado novamente
    if (changes.itens) {
      this.filtrarItens();
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  // Função de filtro genérica e segura
  protected filtrarItens() {
    if (!this.itens) {
      this.itensFiltrados.next([]);
      return;
    }

    // Verifica se o filtroCtrl já foi definido
    let search = this._filtroCtrl ? this._filtroCtrl.value : '';
    if (!search) {
      this.itensFiltrados.next(this.itens.slice());
      return;
    }
    search = search.toLowerCase();
    this.itensFiltrados.next(
      this.itens.filter(item => {
        const propValue = item[this.searchProperty];
        // Verifica se a propriedade existe e é uma string para evitar erros
        return propValue && typeof propValue === 'string' && propValue.toLowerCase().includes(search);
      })
    );
  }
}
